import { render, staticRenderFns } from "./openchart.vue?vue&type=template&id=6fe5d9bd&scoped=true&"
import script from "./openchart.vue?vue&type=script&lang=js&"
export * from "./openchart.vue?vue&type=script&lang=js&"
import style0 from "./openchart.vue?vue&type=style&index=0&id=6fe5d9bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe5d9bd",
  null
  
)

export default component.exports